import { STRINGS } from "../outboundAmzl/util/Constants";
import { getStationCode } from "../network/NetworkUtil";

const postMessagePromises = {};
function generateGuid() {
  /**
   * @return {string}
   */
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  return (
    S4() +
    S4() +
    "-" +
    S4() +
    "-4" +
    S4().substr(0, 3) +
    "-" +
    S4() +
    "-" +
    S4() +
    S4() +
    S4()
  ).toLowerCase();
}

function postMessagePromised(targetWindow, message, targetOrigin, timeout) {
  const newGuid = generateGuid();
  message.guid = newGuid;
  postMessagePromises[newGuid] = {};
  postMessagePromises[newGuid]["promise"] = new Promise(function (
    resolve,
    reject,
  ) {
    postMessagePromises[newGuid]["resolve"] = resolve;
    postMessagePromises[newGuid]["reject"] = reject;
    targetWindow.postMessage(message, targetOrigin);
    if (timeout) {
      setTimeout(() => {
        postMessagePromises[newGuid].resolve(STRINGS.TIMEOUT);
      }, timeout);
    }
  });
  return postMessagePromises[newGuid].promise;
}

var setCurrentDarkMode = () => {};
export function setDarkModeStateListener(darkModeStateListener) {
  setCurrentDarkMode = darkModeStateListener;
}

export async function getTcpRoles() {
  return await postMessagePromised(
    window.parent,
    {
      method: "getTcpRoles",
      args: {},
    },
    "*",
    200,
  );
}

export async function getTCPRolesWithRootStations() {
  return await postMessagePromised(
    window.parent,
    {
      method: "getTCPRolesWithRootStations",
      args: {},
    },
    "*",
    200,
  );
}

export async function getUserLoginFromParent() {
  return await postMessagePromised(
    window.parent,
    {
      method: "getTcpEmployeeLogin",
      args: {},
    },
    "*",
    200,
  );
}

export async function getStowWipComplianceAPIEnabled() {
  return await postMessagePromised(
    window.parent,
    {
      method: "isStowWipComplianceEnabled",
      args: {},
    },
    "*",
    200,
  );
}

export async function getUserNameFromParent() {
  return await postMessagePromised(
    window.parent,
    {
      method: "getEmployeeName",
      args: {},
    },
    "*",
    200,
  );
}

export function publishClientSideMetrics(args) {
  window.parent.postMessage(
    {
      method: "publishClientSideMetrics",
      args: args,
    },
    "*",
  );

  const stationArgs = {
    ...args,
    processName: args.processName + "_" + getStationCode(),
  };
  window.parent.postMessage(
    {
      method: "publishClientSideMetrics",
      args: stationArgs,
    },
    "*",
  );
}

export function publishCustomMetrics(args) {
  window.parent.postMessage(
    {
      method: "logCustomEventMetrics",
      args: args,
    },
    "*",
  );
}

export async function getCycleDataFromParent() {
  return await postMessagePromised(
    window.parent,
    {
      method: "getCycleDataFromParent",
      args: {},
    },
    "*",
  );
}

export async function getNodeCapability() {
  return await postMessagePromised(
    window.parent,
    {
      method: "getNodeCapability",
      args: {},
    },
    "*",
  );
}

export async function getDarkModeStatus() {
  return await postMessagePromised(
    window.parent,
    {
      method: "getDarkModeStatus",
      args: {},
    },
    "*",
  );
}

export async function getOverviewQualityMetricsFlag() {
  return await postMessagePromised(
    window.parent,
    {
      method: "getOverviewQualityMetricsFlag",
      args: {},
    },
    "*",
  );
}

export async function getAPIGatewayDataFromParent(args) {
  return await postMessagePromised(
    window.parent,
    {
      method: "getAPIGatewayDataFromParent",
      args: args,
    },
    "*",
  );
}

export async function postGenericFromParent(args, url) {
  return await postMessagePromised(
    window.parent,
    {
      method: "postGenericFromParent",
      url: url,
      args: args,
    },
    "*",
  );
}

export async function getCoralServiceDataFromParent(args) {
  return await postMessagePromised(
    window.parent,
    {
      method: "getCoralServiceDataFromParent",
      args: args,
    },
    "*",
  );
}

export async function getOverviewData(args) {
  return await postMessagePromised(
    window.parent,
    {
      method: "getOverviewData",
      args: args,
    },
    "*",
  );
}

export async function getDocumentURL() {
  return await postMessagePromised(
    window.parent,
    {
      method: "getDocumentURL",
      args: {},
    },
    "*",
  );
}

export async function getLocaleFromParent() {
  return await postMessagePromised(
    window.parent,
    {
      method: "getLocale",
      args: {},
    },
    "*",
    200,
  );
}

export async function getCountryCodeFromParent() {
  return await postMessagePromised(
    window.parent,
    {
      method: "getCountryCode",
      args: {},
    },
    "*",
    200,
  );
}

export function setSelectedCycle(selectedCycle) {
  window.parent.postMessage(
    {
      method: "setSelectedCycle",
      args: { selectedCycle: selectedCycle },
    },
    "*",
  );
}

export async function updatePlansAndTarget(args) {
  return await postMessagePromised(
    window.parent,
    {
      method: "updatePlansAndTarget",
      args: args,
    },
    "*",
  );
}

export async function updateStationTargets(args) {
  return await postMessagePromised(
    window.parent,
    {
      method: "updateStationTargets",
      args: args,
    },
    "*",
  );
}

export async function deletePlan(args) {
  return await postMessagePromised(
    window.parent,
    {
      method: "deletePlan",
      args: args,
    },
    "*",
  );
}

export async function getRuleConfigurations(args) {
  return await postMessagePromised(
    window.parent,
    {
      method: "getRuleConfigurations",
      args: args,
    },
    "*",
  );
}

export async function setShiftPlanSettings(args) {
  return await postMessagePromised(
    window.parent,
    {
      method: "setShiftPlanSettings",
      args: args,
    },
    "*",
  );
}

export async function getShiftPlanSettings(args) {
  return await postMessagePromised(
    window.parent,
    {
      method: "getShiftPlanSettings",
      args: args,
    },
    "*",
  );
}

export async function setECCFLaborAvailabilityData(args) {
  return await postMessagePromised(
    window.parent,
    {
      method: "setECCFLaborAvailabilityData",
      args: args,
    },
    "*",
  );
}

export async function getECCFLaborAvailabilityData(args) {
  const result = await postMessagePromised(
    window.parent,
    {
      method: "getECCFLaborAvailabilityData",
      args: args,
    },
    "*",
  );
  return result;
}

export async function updateRuleConfigurations(args) {
  return await postMessagePromised(
    window.parent,
    {
      method: "updateRuleConfigurations",
      args: args,
    },
    "*",
  );
}

export async function deleteRuleConfigurations(args) {
  return await postMessagePromised(
    window.parent,
    {
      method: "deleteRuleConfigurations",
      args: args,
    },
    "*",
  );
}

export async function getFeatureStatus(features) {
  return await postMessagePromised(
    window.parent,
    {
      method: "getFeatureStatus",
      args: { features, stationCode: getStationCode() },
    },
    "*",
  );
}

export async function getTriggerConfigurations(args) {
  return await postMessagePromised(
    window.parent,
    {
      method: "getTriggerConfigurations",
      args: args,
    },
    "*",
  );
}

export async function updateTriggerConfiguration(args) {
  return await postMessagePromised(
    window.parent,
    {
      method: "updateTriggerConfiguration",
      args: args,
    },
    "*",
  );
}

export async function deleteTriggerConfiguration(args) {
  return await postMessagePromised(
    window.parent,
    {
      method: "deleteTriggerConfiguration",
      args: args,
    },
    "*",
  );
}

/**
 * Notify parent window of selected roles changes
 * @param {string[]} roles - Array of selected roles
 */
export function notifyParentOfSelectedRoles(roles) {
  window.parent.postMessage(
    {
      method: "selectedRolesResponse",
      roles: roles,
    },
    "*",
  );
}

window.addEventListener("message", onNewPostMessageFromParent, false);

function onNewPostMessageFromParent(event) {
  if (
    event.data.method &&
    subscribeAbleEvents.hasOwnProperty(event.data.method)
  ) {
    subscribeAbleEvents[event.data.method](event.data);
  }
}

const subscribeAbleEvents = {
  sendCycleDataToChild: sendCycleDataToChild,
  sendApiGatewayResponse: sendApiGatewayResponse,
  postGenericFromParentResponse: postGenericFromParentResponse,
  sendOverviewResponse: sendOverviewResponse,
  sendCapabilityResponse: sendCapabilityResponse,
  sendDocumentURL: sendDocumentURL,
  sendUpdatePlansAndTargetResponse: sendUpdatePlansAndTargetResponse,
  sendUpdateStationTargetsResponse: sendUpdateStationTargetsResponse,
  sendDeletePlanResponse: sendDeletePlanResponse,
  sendLocaleResponse: sendResponse,
  sendCountryCodeResponse: sendResponse,
  sendCoralServiceData: sendCoralServiceData,
  sendRuleConfigurationsResponse: sendRuleConfigurationsResponse,
  sendUpdateRuleConfigurationsResponse: sendUpdateRuleConfigurationsResponse,
  sendDeleteRuleConfigurationsResponse: sendDeleteRuleConfigurationsResponse,
  sendFeatureStatus: sendFeatureStatus,
  sendTcpRolesResponse: sendTcpRolesResponse,
  sendTcpRolesWithRootStationsResponse: sendTcpRolesWithRootStationsResponse,
  sendEmployeeNameResponse: sendEmployeeNameResponse,
  sendTcpEmployeeLoginResponse: sendTcpEmployeeLoginResponse,
  sendDarkModeStatus: sendDarkModeStatus,
  sendGetShiftPlanSettingsResponse: sendGetShiftPlanSettingsResponse,
  sendSetShiftPlanSettingsResponse: sendSetShiftPlanSettingsResponse,
  sendTriggerConfigurationsResponse: sendTriggerConfigurationsResponse,
  sendUpdateTriggerConfigurationsResponse:
    sendUpdateTriggerConfigurationsResponse,
  sendDeleteTriggerConfigurationsResponse:
    sendDeleteTriggerConfigurationsResponse,
  sendOverviewQualityMetricsFlag: sendOverviewQualityMetricsFlag,
  sendSetECCFLaborAvailabilityDataResponse:
    sendSetECCFLaborAvailabilityDataResponse,
  sendGetECCFLaborAvailabilityDataResponse:
    sendGetECCFLaborAvailabilityDataResponse,
  sendStowWipComplianceEnabled: sendStowWipComplianceEnabled,
};

function sendDarkModeStatus(data) {
  if (data.childData.capability === "dark") {
    setCurrentDarkMode("dark");
    document.body.classList.add("dark-mode");
  } else {
    setCurrentDarkMode("light");
    document.body.classList.remove("dark-mode");
  }
}

function sendCoralServiceData(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.responseData);
  }
}

function sendOverviewQualityMetricsFlag(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.childData);
  }
}

function sendCycleDataToChild(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.childData);
  }
}

function sendCapabilityResponse(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.childData);
  }
}

function sendApiGatewayResponse(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.responseData);
  }
}

function postGenericFromParentResponse(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.responseData);
  }
}

function sendOverviewResponse(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.responseData);
  }
}

function sendDocumentURL(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.responseData);
  }
}

function sendUpdatePlansAndTargetResponse(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.responseData);
  }
}

function sendUpdateStationTargetsResponse(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.responseData);
  }
}

function sendDeletePlanResponse(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.responseData);
  }
}

function sendResponse(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.childData);
  }
}

function sendRuleConfigurationsResponse(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.responseData);
  }
}

function sendTriggerConfigurationsResponse(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.responseData);
  }
}

function sendUpdateTriggerConfigurationsResponse(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.responseData);
  }
}

function sendDeleteTriggerConfigurationsResponse(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.responseData);
  }
}

function sendGetShiftPlanSettingsResponse(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.responseData);
  }
}

function sendSetShiftPlanSettingsResponse(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.responseData);
  }
}

function sendUpdateRuleConfigurationsResponse(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.responseData);
  }
}

function sendDeleteRuleConfigurationsResponse(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.responseData);
  }
}

function sendFeatureStatus(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.responseData);
  }
}

function sendEmployeeNameResponse(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.childData);
  }
}

function sendTcpRolesResponse(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.childData);
  }
}

function sendTcpRolesWithRootStationsResponse(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.childData);
  }
}

function sendTcpEmployeeLoginResponse(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.childData);
  }
}

function sendSetECCFLaborAvailabilityDataResponse(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.responseData);
  }
}

function sendGetECCFLaborAvailabilityDataResponse(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.responseData);
  }
}

function sendStowWipComplianceEnabled(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.childData);
  }
}



// WEBPACK FOOTER //
// ./src/components/handler/ParentDataHandler.js